import * as React from 'react';
import { Text } from '@grandvisionhq/elements';
import { useLink } from '@grandvisionhq/frk-routing';
import { H2 } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { makeOrderDetailsClickEvent } from '../../../data-layer/utils.js';
import { logOrderEvent } from '../../../data-layer/orders.js';
import '@grandvisionhq/analytics';
import OrderListItem from './OrderListItem.js';

const OrderListItemContainer = ({ lineItems , orderDate , orderNumber , paymentStatus , shouldShowOrderDate =true ,  })=>{
    const { dateTime , getLabel  } = useIntl();
    var ref;
    const { href , onClick  } = (ref = useLink({
        route: 'me.orders.detail',
        params: {
            orderId: orderNumber
        }
    })) !== null && ref !== void 0 ? ref : {};
    const labels = {
        order: getLabel('common.order'),
        viewDetails: getLabel('account.common.viewDetails')
    };
    const handleOnClick = (e)=>{
        logOrderEvent(makeOrderDetailsClickEvent('my_online_orders', orderNumber, paymentStatus));
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "order-list-item",
        key: orderNumber
    }, /*#__PURE__*/ React.createElement("div", {
        className: "order-list-item__header"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(H2, {
        className: "order-list-item__order-number",
        variant: "smallest"
    }, labels.order, " ", orderNumber)), shouldShowOrderDate && /*#__PURE__*/ React.createElement(Text, {
        variant: "body",
        color: "text-secondary"
    }, dateTime.formatMidsizeDate(orderDate))), lineItems.map((lineItem)=>/*#__PURE__*/ React.createElement(OrderListItem, {
            key: `${lineItem.title}-${lineItem.subtitle}`,
            header: lineItem.title,
            subtitle: lineItem.subtitle,
            imageUrl: lineItem.imageUrl,
            href: href,
            onClick: handleOnClick,
            labels: labels
        })
    ));
};

export { OrderListItemContainer as default };
//# sourceMappingURL=OrderListItemContainer.js.map
